import "./JoinTheForce.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MissionControl from "./sections/MissionControl";
import OurTrainingGrounds from "./sections/OurTrainingGrounds";
import TheBasecamp from "@/reusable_sections/Footer";
export default function JoinTheForcePage() {
  return <div>
      <MainNavigation />
      <MissionControl />
      <OurTrainingGrounds />
      <TheBasecamp />
    </div>;
}